<!-- <div class="conteiner">
  <div class="row">
    <div class="col"><h3>Selecione um ambiente</h3></div>
  </div>
  <div class="row">
    <div class="col">
      <div class="box-ambientes" *ngFor="this.environment.api.environments">
        <ul>
          <li *ngFor="let product of items">
          {{product}}
          </li>
         </ul>
         dghdf
      </div>
    </div>
  </div>
</div> -->

<div class="Modal">
  <h1>Hello World</h1>
</div>